let slider_id: number = 0;

export const slider_id_hotel_rooms_reserves: string = `${slider_id++}`;
export const slider_id_hotel_stays_rooms_stays: string = `${slider_id++}`;
export const slider_id_hotel_stays_timespan: string = `${slider_id++}`;
export const slider_id_hotel_stays_occupied: string = `${slider_id++}`;
export const slider_id_hotel_stays_graph: string = `${slider_id++}`;
